module.exports = __webpack_public_path__ + "img/8O0A4269.8426b7a4.png";